import { Directive, OnInit, Input, ViewContainerRef } from '@angular/core';
import { Address } from '../../model/interfaces/address';
import { DawaAddressService } from '../../services/dawa-address.service';
import { Validator, ValidatorBase } from '../core/model';

@Directive({
    selector: "[dawa-address-validator]",
    host: { '(input)': 'onInput($event)' },
    exportAs: 'validator'
})
export class DawaAddressValidatorDirective extends ValidatorBase implements Validator
{
    @Input('dawa-address-validator')
    public getValue: () => string;

    @Input('address')
    public address: Address;

    public valid: boolean;

    private readonly dawaAddressService: DawaAddressService;

    public constructor(viewRef: ViewContainerRef, dawaAddressService: DawaAddressService)
    {
        super(viewRef);
        this.elementRef = viewRef.element.nativeElement;
        this.dawaAddressService = dawaAddressService;
    }

    public onInput(event: KeyboardEvent): void
    {
        this.valid = this.isValid();
        if (this.valid == false)
        {
            this.valid = undefined;
        }
    }

    protected isValid(): boolean
    {
        if (this.address == null) {
          return false;
        }

        const fieldAddressText = this.elementRef.value.toLowerCase() as string;
        const formattedAddressText = this.dawaAddressService
          .formatAddress(this.address)
          .toLowerCase();

        return fieldAddressText === formattedAddressText;
    }
}
